import type { SxProps, Theme } from '@/ui/primitives';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;

type BuildCoverageTimelinePlotAreaSurfaceSxArgs = {
  backgroundColor: string;
  borderColor: string;
};

export const buildCoverageTimelinePlotAreaSurfaceSx = ({
  backgroundColor,
  borderColor,
}: BuildCoverageTimelinePlotAreaSurfaceSxArgs): ThemeSxObject => ({
  backgroundColor,
  border: '1px solid',
  borderColor,
  boxSizing: 'border-box',
});
